<template>
    <b-button v-if="isAvailable" :to="link" target="_blank" class="btn-card-action btn-card-action-green my-1"> Сформировать итоговый протокол </b-button>
</template>

<script>
export default {
    name: 'cabinet-fl44-notice-card-store-protocol-button',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    computed: {
        isAvailable() {
            return this.purchase.actions.store_protocol;
        },
        link() {
            return this.purchase.type === 'fl44' ? { name: 'purchases.grouped.item.view', params: { group: 'fl44', id: this.purchase.id }, hash: '#atmo-protocol-completion' } : { name: 'Fl44UnknownVolumePurchaseShow', params: { id: this.purchase.id }, hash: '#atmo-protocol-completion' };
        }
    }
};
</script>
